export default "__VITE_ASSET__5ApLWOtk__"